export const Twitter = () => (
  <ul className=" list-decimal  pl-4 mb-0">
    <li>
      Make a copy of this{" "}
      <a
        href="https://docs.google.com/spreadsheets/d/1ffIP4w0wMRI2Kh0DykrTRryTXsubz4v2Tan5H83ZOeM/edit?usp=sharing"
        target="_blank"
        rel="noreferrer"
      >
        URL Builder Google Sheet
      </a>
      .
    </li>
    <li>
      Enter in your campaign, ad group and ad names to be able to create the URL
      with UTMs attached.
    </li>
  </ul>
);
